import bootstrap from '../../utils/bootstrap';
import { EmbedBrowserModule } from './embed.browser.module';

bootstrap(EmbedBrowserModule);
